$(function () {
    var upsellRestrictionsData = {
        relationshipData: [
          {
                upsellHandle: 'diffuser-glass-bottle-single',
                upsellVariantId: 41181166338242,
                upsellTriggerVariantIds: [48113523392804] // Updated to Variant ID 
          },
          {
                upsellHandle: '2x-extra-diffuser-glass-bottles',
                upsellVariantId: 42156868763842,
                upsellTriggerVariantIds: [48113523392804] // Updated to Variant ID 
          },
          {
                upsellHandle: 'extra-100ml-air-freshener-9-pack-with-same-fragrances-35-offs',
                upsellVariantId: 42621070835906,
                upsellTriggerVariantIds: [48114072846628] // Updated to Variant ID 
          },
          {
                upsellHandle: 'second-pyjama-foundation-bottle-lollies',
                upsellVariantId: 46611228885284,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'second-pyjama-foundation-bottle-loopz',
                upsellVariantId: 46611228950820,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'second-pyjama-foundation-bottle-sherbet',
                upsellVariantId: 46611228983588,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'second-pyjama-foundation-bottle-snakes',
                upsellVariantId: 46611228852516,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'second-pyjama-foundation-bottle-sour',
                upsellVariantId: 46611228918052,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'copy-of-the-pyjama-foundation-range-lollies',
                upsellVariantId: 46498855256356,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'copy-of-the-pyjama-foundation-range-loopz',
                upsellVariantId: 46498855321892,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'copy-of-the-pyjama-foundation-range-sherbet',
                upsellVariantId: 46498855354660,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'copy-of-the-pyjama-foundation-range-snakes',
                upsellVariantId: 46498855223588,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'copy-of-the-pyjama-foundation-range-sour',
                upsellVariantId: 46498855289124,
                upsellTriggerVariantIds: [48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: 'pink-champagne-tropical-fruits-air-freshener-not-yet-released',
                upsellVariantId: 49536801276196,
                upsellTriggerVariantIds: [42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-bush',
                upsellVariantId: 49490621628708,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-lime',
                upsellVariantId: 49490666783012,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244.49805036224804,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-sticks',
                upsellVariantId: 49490621661476,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-frogs',
                upsellVariantId: 49490621727012,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-tangerine',
                upsellVariantId: 49490621825316,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-teakwood',
                upsellVariantId: 49490621792548,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-tigerlilly',
                upsellVariantId: 49490621759780,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          {
                upsellHandle: '1x-car-freshener-100ml-au-sandalwood',
                upsellVariantId: 49490621858084,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-rainforest',
          //       upsellVariantId: 49169811800356,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-vanilla',
          //       upsellVariantId: 49169811603748,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-popcorn',
          //       upsellVariantId: 49169811636516,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-lime',
          //       upsellVariantId: 49169811734820,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-martini',
          //       upsellVariantId: 49169811767588,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-musk',
          //       upsellVariantId: 49169811702052,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,9751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-frogs',
          //       upsellVariantId: 49169811669284,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          // {
          //       upsellHandle: 'reed-diffuser-set-with-1x-refill-1x-glass-bottle-and-1x-bundle-of-reed-sticks-caramel',
          //       upsellVariantId: 49169811833124,
          //       upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940,49801988014372,49758866506020,49801933095204,48928321306916,49734106317092,49702504333604,49702418383140,49867946557732,49576639824164,49576639856932,49576639889700] // Updated to Variant ID 
          // },
          {
                upsellHandle: '1x-perfume-oil-bloom',
                upsellVariantId: 49886260363556,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
            
          },
           {
                upsellHandle: '1x-perfume-oil-ease',
                upsellVariantId: 49886259675428,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
            
          },
          {
                upsellHandle: '1x-perfume-oil-funday',
                upsellVariantId: 49886256824612,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
            
          },
          {
                upsellHandle: '1x-perfume-oil-triumphant',
                upsellVariantId: 49886265704740,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
            
          },
          {
                upsellHandle: '1x-perfume-oil-tuscan',
                upsellVariantId: 49886266949924,
                upsellTriggerVariantIds: [49751995482404,49751998169380,49751943545124,49751945150756,49805036257572,49867785470244,49805036224804,49670906380580,42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
            
          },
          {
                upsellHandle: 'discovery-set',
                upsellVariantId: 48768203784484,
                upsellTriggerVariantIds: [42164397736130,48768203784484,48114072781092,48114072813860,48114072846628,49124933042468,48113474601252,48113523392804,48113506058532,48339441778980,49570548973860,48142294286628,48114094407972,48114096210212,48114065604900,48114089656612,48113492525348,48113492590884,48113492656420,49163494719780,48081621221668,48253981229348,48907420827940] // Updated to Variant ID 
          },
          {
            upsellHandle: '1x-extra-collar-choose-colour-flamingo',
            upsellVariantId: 49687889412388,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-collar-choose-colour-sky-blue',
            upsellVariantId: 49687889445156,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-collar-choose-colour-midnight',
            upsellVariantId: 49687889477924,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-collar-choose-colour-wasabi',
            upsellVariantId: 49691702198564,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-diffuser-bottle-gold-collar-flamingo',
            upsellVariantId: 49691711275300,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-diffuser-bottle-gold-collar-sky-blue',
            upsellVariantId: 49691711308068,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-diffuser-bottle-gold-collar-midnight',
            upsellVariantId: 49691711340836,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '1x-extra-diffuser-bottle-gold-collar-wasabi',
            upsellVariantId: 49691711373604,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: 'save-10-3x-extra-diffuser-bottles-mixed',
            upsellVariantId: 49691722514724,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: 'save-10-3x-extra-diffuser-bottles-flamingo',
            upsellVariantId: 49691720089892,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084, 50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: 'save-10-3x-extra-diffuser-bottles-sky-blue',
            upsellVariantId: 49691720122660,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084, 50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: 'save-10-3x-extra-diffuser-bottles-midnight',
            upsellVariantId: 49691720155428,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: 'save-10-3x-extra-diffuser-bottles-wasabi',
            upsellVariantId: 49691720220964,
            upsellTriggerVariantIds: [49670906380580,49670906413348,48339441778980,49867916214564,49570548973860,50002216354084,50055687307556,50055685931300,50067741376804,50067751469348,50101009023268]
          },
          {
            upsellHandle: '3x-night-light-diffuser-sticks',
            upsellVariantId: 50002146459940,
            upsellTriggerVariantIds: [48113506058532,49881159663908,48114065604900,48114089656612,50002272911652,50002253087012,50002263540004,50002268356900]
          },
          {
            upsellHandle: '6x-night-light-diffuser-sticks',
            upsellVariantId: 50002293489956,
            upsellTriggerVariantIds: [50002272911652,50002253087012,50002263540004,50002268356900,48114065604900,48114089656612,48113506058532,49881159663908]
          },
          {
            upsellHandle: '40-off-1x-reed-diffuser-refill-reed-sticks-pc',
            upsellVariantId: 50275810115876,
            upsellTriggerVariantIds: [48339441778980, 49570548973860, 49867916214564, 49670906380580, 49670907756836, 49671123599652]
          },
          {
            upsellHandle: '40-off-1x-reed-diffuser-refill-reed-sticks-em',
            upsellVariantId: 50316768248100,
            upsellTriggerVariantIds: [48339441778980, 49570548973860, 49867916214564, 49670906380580, 49670907756836, 49671123599652]
          },
        ]
    };

    function enforceUpsellRestrictions(cart, refreshAfterUpdate = true) {
        var updateRequired = false;

        var quantityUpdates = {
            updates: {}
        };

        for (var i = 0; i < upsellRestrictionsData.relationshipData.length; i++) {
            var upsellInCart = false;
            var triggerInCart = false;

            var relationshipData = upsellRestrictionsData.relationshipData[i];

            for (var j = 0; j < cart.items.length; j++) {
                var itemProductId = cart.items[j].product_id;
                var itemVariantId = cart.items[j].variant_id;

                if (itemVariantId == relationshipData.upsellVariantId) {
                    upsellInCart = true;
                }

                if (relationshipData.upsellTriggerVariantIds.includes(itemVariantId)) {
                    triggerInCart = true;
                }
              
              //restriction to avoid purchase of items without a full priced item
                if (cart.items.length == 1){
                  if(itemVariantId == 48077439009060){              
                   quantityUpdates.updates[48077439009060] = 0;
                    updateRequired = true;
                  }
                  else if(itemProductId == 9883069841700){
                    quantityUpdates.updates[itemVariantId] = 0;
                    updateRequired = true;
                  }  
                  else if(itemVariantId == 48077412303140){
                    quantityUpdates.updates[48077412303140] = 0;
                    updateRequired = true;
                  }      
                   else if(itemVariantId == 48627044647204){
                    quantityUpdates.updates[48627044647204] = 0;
                    updateRequired = true;
                  } 
                   
               }
              if(cart.items.length == 2){
                var firstproduct = cart.items[0].variant_id;
                var secondproduct = cart.items[0].variant_id;
                if (firstproduct == 48077439009060  &&  secondproduct == 48077412303140)
                {
                  quantityUpdates.updates[48077412303140] = 0;
                  updateRequired = true;
                }
              }
              
            }

            if (upsellInCart && !triggerInCart) {
                quantityUpdates.updates[relationshipData.upsellVariantId] = 0;
                updateRequired = true;
            }
        }
      console.log(upsellInCart+' '+triggerInCart);

        if (updateRequired) {
            xhook.disable();
            $.ajax({
                url: '/cart/update.js',
                method: 'POST',
                data: quantityUpdates,
                success: (res) => {
                    if (refreshAfterUpdate) {
                        window.location.reload();
                    }
                },
                error: (err) => {
                    console.log(err);
                },
                always: () => {
                    xhook.enable();
                }
            });
        }
    }
  var restrictedVariants = [41321591800002, 41321591734466]
  var isAddingGift = false;
  
   function autoAddToCart(cart,refreshAfterUpdate = true){
    // Prevent duplicate add requests
    if (isAddingGift) return;

      var giftItemExists = false;
      var triggerItemExists = false;
      //var totalCartValue = 0;

      // Variants that block the auto-add of the 3 free sprays
      var exclusionList = [
        50403040493860, 48318369595684, 50626609152292, 50704524706084, 
        48318370677028, 48318370742564, 48318369562916, 50347669913892,
      ];

      var triggerItems = [51377569300772]
      
      var hasExcludedVariant = false;
  
       for (var j = 0; j < cart.items.length; j++) {
         var itemVariantId = cart.items[j].variant_id;
         //totalCartValue = totalCartValue + cart.items[j].discounted_price * cart.items[j].quantity;
         
         if (itemVariantId == 67768268194084){
           giftItemExists = true;
         }

         // Check if any item in the cart is in our exclusion list
         if (exclusionList.includes(itemVariantId)) {
           hasExcludedVariant = true;
         }

         if(triggerItems.includes(itemVariantId)) {
          triggerItemExists = true;
         }
       }
      // Only trigger the gift if the value is met AND no excluded variants are present
      // if (!hasExcludedVariant &&  cart.items.length >= 1 ){
      //   triggerItemExists = true;
      // }

      if (cart.items.length == 1 && restrictedVariants.includes(itemVariantId)){
        triggerItemExists = false;
      }

      if (giftItemExists === false && triggerItemExists === true)
      {
        isAddingGift = true;
        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            data: {
                    'items': [{
                    'id': 67768268194084,
                    'quantity': 1,
                    // 'properties': {
                    //   "Bottle 1": "Grandma’s Biscuit",
                    //   "Bottle 2": "Gorilla Snot",
                    //   "Bottle 3": "Custard Tart"
                    // }
                  }]
                },
            success: (cartData) => {
            window.location.reload();
            }
        });
      }
      else if ((!triggerItemExists ||  hasExcludedVariant) && giftItemExists  ){
        // Remove the gift if the total drops OR if an excluded variant is added
        var quantityUpdates = {
            updates: {
              '67768268194084' : 0
            }
        };
         $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            data: quantityUpdates,
            success: (cartData) => {
             window.location.reload();
            }
        });
      }
    }

    function updateUpsellRestrictions(request) {
        $.ajax({
            url: '/cart.js',
            method: 'POST',
            dataType: 'json',
            success: (cartData) => {
                enforceUpsellRestrictions(cartData, true);
               if (request != "/cart/clear.js" && request != "/cart/update.js" && request != "/cart/change.js"){
                  //autoAddToCart(cartData, true)
               }
            }
        });
    }

    updateUpsellRestrictions();
    xhook.after(function (request, response) {
     
      let url = request.url;
        if (request && (url.includes("add") || url.includes("change") || url.includes("update") || url.includes("clear"))) {
           console.log("request", request);
            updateUpsellRestrictions(request.url);
        }
    });
});